import React from 'react';

interface CardHeaderProps {
  icon?: string;
  title: string;
  subtitle?: React.ReactNode;
  className?: string;
  iconSize?: string;
  progressValue?: number;
  /**
   * Controls whether the header icon should be displayed. If not explicitly set,
   * the icon will be hidden even if the `icon` prop is provided. This allows
   * pages to opt-in to showing the logo without changing existing usages.
   */
  showIcon?: boolean;
}

const CardHeader: React.FC<CardHeaderProps> = ({ 
  icon, 
  title, 
  subtitle, 
  className = '',
  iconSize = 'w-24 h-24',
  progressValue,
  showIcon = false
}) => {
  return (
    <div className={`card-header flex-shrink-0 px-6 pt-4 pb-2 ${className}`}>
      {/* Icon */}
      {showIcon && icon && (
        <div className="w-full flex flex-col items-center justify-center pt-2 pb-3">
          <img
            src={icon}
            alt={title}
            className={`${iconSize} object-contain`}
            style={{ maxHeight: '160px', maxWidth: '100%' }}
          />
        </div>
      )}

      {/* Title and Subtitle */}
      <div className="flex-col justify-start items-center gap-3 flex text-center mt-12">
        <div className="text-black text-2xl sm:text-3xl font-bold leading-relaxed">
          {title}
        </div>
        {subtitle && (
          <div className="text-gray-600 text-base sm:text-lg text-center leading-relaxed">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardHeader; 